// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaseActivitySection_root__M9s5f {
  margin-top: 20px;
}

.CaseActivitySection_title_container__UHLgs {
  margin-bottom: 30px;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
}

.CaseActivitySection_title_font__ad4mK {
  font-weight: 600 !important;
  cursor: default;
  font-size: 20px;
}

.CaseActivitySection_add_note_button__2ctPG {
  color: var(--color-font-10) !important;
  border-color: var(--color-font-10) !important;
  position: relative;
  z-index: 99;
}

.CaseActivitySection_title_right_side__yMOJj {
  display: flex;
}

.CaseActivitySection_future_section_hidden__INebn {
  animation-name: CaseActivitySection_heigthChangeBack__x3Zdq;
  animation-duration: 1500ms;
  overflow: hidden;
  max-height: 0px;
}

.CaseActivitySection_future_section_visible__tkgF3 {
  animation-name: CaseActivitySection_heigthChange__YRHkB;
  animation-duration: 1500ms;
  overflow: hidden;
}

/* Space between high-priority activities and scheduled emails (no divider line) */
.CaseActivitySection_after_priority_gap__yzZv- {
  margin-top: 24px;
}

.CaseActivitySection_future_section_hidden_no_animation__1-2Jt {
  overflow: hidden;
  max-height: 0px;
}

.CaseActivitySection_future_section_visible_no_animation__lbURx {
  overflow: hidden;
}

@keyframes CaseActivitySection_heigthChange__YRHkB {
  from {
    max-height: 0px;
  }
  to {
    max-height: 4000px;
  }
}

@keyframes CaseActivitySection_heigthChangeBack__x3Zdq {
  from {
    max-height: 900px;
  }
  to {
    max-height: 0px;
  }
}

.CaseActivitySection_activity_container__ClAhY {
  margin-bottom: 15px;
}

.CaseActivitySection_activity_container_more_button__vszSt {
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
}

.CaseActivitySection_loading__\\+bY2l {
  width: 100%;
  text-align: center;
  color: black;
}

.CaseActivitySection_devider_container__8D\\+Nj {
  display: flex;
  align-items: center;
  margin: 20px 0px;
}

.CaseActivitySection_devider_border__FSd9l {
  border-bottom: 2px solid black;
  width: 100%;
}

.CaseActivitySection_devider_content__QmEiK {
  padding: 0 10px 0 10px;
  font-weight: bold;
  margin: 0px 60px;
  white-space: nowrap;
}

.CaseActivitySection_priority_divider_container__SwVme {
  display: flex;
  align-items: center;
  margin: 20px 0px;
}

.CaseActivitySection_priority_divider_border__ZbRR8 {
  border-bottom: 1px solid var(--color-theme-cloud);
  width: 100%;
}

.CaseActivitySection_priority_divider_content__JzPCc {
  padding: 0 10px 0 10px;
  font-size: 12px;
  color: var(--color-font-10);
  white-space: nowrap;
}

.CaseActivitySection_flex_right__GWCF2 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 25px;
}

.CaseActivitySection_filter_empty_message__bYtNb {
  text-align: center;
  font-size: 14px;
  color: var(--color-font-10);
  padding: 24px 0;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/sections/CaseActivitySection/CaseActivitySection.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2DAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uDAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":[".root {\n  margin-top: 20px;\n}\n\n.title_container {\n  margin-bottom: 30px;\n\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.title_font {\n  font-weight: 600 !important;\n  cursor: default;\n  font-size: 20px;\n}\n\n.add_note_button {\n  color: var(--color-font-10) !important;\n  border-color: var(--color-font-10) !important;\n  position: relative;\n  z-index: 99;\n}\n\n.title_right_side {\n  display: flex;\n}\n\n.future_section_hidden {\n  animation-name: heigthChangeBack;\n  animation-duration: 1500ms;\n  overflow: hidden;\n  max-height: 0px;\n}\n\n.future_section_visible {\n  animation-name: heigthChange;\n  animation-duration: 1500ms;\n  overflow: hidden;\n}\n\n/* Space between high-priority activities and scheduled emails (no divider line) */\n.after_priority_gap {\n  margin-top: 24px;\n}\n\n.future_section_hidden_no_animation {\n  overflow: hidden;\n  max-height: 0px;\n}\n\n.future_section_visible_no_animation {\n  overflow: hidden;\n}\n\n@keyframes heigthChange {\n  from {\n    max-height: 0px;\n  }\n  to {\n    max-height: 4000px;\n  }\n}\n\n@keyframes heigthChangeBack {\n  from {\n    max-height: 900px;\n  }\n  to {\n    max-height: 0px;\n  }\n}\n\n.activity_container {\n  margin-bottom: 15px;\n}\n\n.activity_container_more_button {\n  margin-bottom: 15px;\n  display: flex;\n  justify-content: center;\n}\n\n.loading {\n  width: 100%;\n  text-align: center;\n  color: black;\n}\n\n.devider_container {\n  display: flex;\n  align-items: center;\n  margin: 20px 0px;\n}\n\n.devider_border {\n  border-bottom: 2px solid black;\n  width: 100%;\n}\n\n.devider_content {\n  padding: 0 10px 0 10px;\n  font-weight: bold;\n  margin: 0px 60px;\n  white-space: nowrap;\n}\n\n.priority_divider_container {\n  display: flex;\n  align-items: center;\n  margin: 20px 0px;\n}\n\n.priority_divider_border {\n  border-bottom: 1px solid var(--color-theme-cloud);\n  width: 100%;\n}\n\n.priority_divider_content {\n  padding: 0 10px 0 10px;\n  font-size: 12px;\n  color: var(--color-font-10);\n  white-space: nowrap;\n}\n\n.flex_right {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-right: 25px;\n}\n\n.filter_empty_message {\n  text-align: center;\n  font-size: 14px;\n  color: var(--color-font-10);\n  padding: 24px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CaseActivitySection_root__M9s5f`,
	"title_container": `CaseActivitySection_title_container__UHLgs`,
	"title_font": `CaseActivitySection_title_font__ad4mK`,
	"add_note_button": `CaseActivitySection_add_note_button__2ctPG`,
	"title_right_side": `CaseActivitySection_title_right_side__yMOJj`,
	"future_section_hidden": `CaseActivitySection_future_section_hidden__INebn`,
	"heigthChangeBack": `CaseActivitySection_heigthChangeBack__x3Zdq`,
	"future_section_visible": `CaseActivitySection_future_section_visible__tkgF3`,
	"heigthChange": `CaseActivitySection_heigthChange__YRHkB`,
	"after_priority_gap": `CaseActivitySection_after_priority_gap__yzZv-`,
	"future_section_hidden_no_animation": `CaseActivitySection_future_section_hidden_no_animation__1-2Jt`,
	"future_section_visible_no_animation": `CaseActivitySection_future_section_visible_no_animation__lbURx`,
	"activity_container": `CaseActivitySection_activity_container__ClAhY`,
	"activity_container_more_button": `CaseActivitySection_activity_container_more_button__vszSt`,
	"loading": `CaseActivitySection_loading__+bY2l`,
	"devider_container": `CaseActivitySection_devider_container__8D+Nj`,
	"devider_border": `CaseActivitySection_devider_border__FSd9l`,
	"devider_content": `CaseActivitySection_devider_content__QmEiK`,
	"priority_divider_container": `CaseActivitySection_priority_divider_container__SwVme`,
	"priority_divider_border": `CaseActivitySection_priority_divider_border__ZbRR8`,
	"priority_divider_content": `CaseActivitySection_priority_divider_content__JzPCc`,
	"flex_right": `CaseActivitySection_flex_right__GWCF2`,
	"filter_empty_message": `CaseActivitySection_filter_empty_message__bYtNb`
};
export default ___CSS_LOADER_EXPORT___;
